import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutSituation, ResumeCard } from "../../components";
import { ContainerResumeCard } from "./styled-components";
import { useParams } from "react-router-dom";
import ProcedureResponse from "../orientation/components/procedure";

import getOrientation from "../../helper/orientations";

const PreProcedure = ({ data, steps }: { data: Domain[]; steps: Step[] }) => {
  const params = useParams();
  const navigate = useNavigate();
  const { domainData, description } = getOrientation(data, params);

  return (
    <LayoutSituation
      steps={steps}
      activeStep={params.domain === "alerte" ? 4 : 3}
      withUrgencyNumber
      onPrevious={() => navigate(`/${params.domain}`)}
    >
      <>
        <ContainerResumeCard>
          <ResumeCard
            title={
              params.domain === "alerte" ? params.theme : domainData?.step.title
            }
            description={description}
          />
        </ContainerResumeCard>
        <ProcedureResponse params={params} />
      </>
    </LayoutSituation>
  );
};

export default PreProcedure;
